export default __webpack_public_path__ + "static/media/47.bf07417c.png";